(function () {
  const CUSTOM_DRAWER_ANIMATION_MS = 260;

  function updateHeaderBottomPosition() {
    const header = document.querySelector('.section-header');
    if (!header) return;

    document.documentElement.style.setProperty(
      '--custom-header-bottom-position',
      Math.round(header.getBoundingClientRect().bottom) + 'px'
    );
  }

  function initMegaMenu(details) {
    if (!details || details.dataset.megaMenuReady === 'true') return;

    const tabs = Array.from(details.querySelectorAll('[data-mega-tab]'));
    const panels = Array.from(details.querySelectorAll('[data-mega-panel]'));
    if (!tabs.length || !panels.length) return;

    function setActive(index) {
      const idx = String(index);

      tabs.forEach(function (tab) {
        const active = tab.dataset.megaTarget === idx;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        const active = panel.dataset.megaPanelIndex === idx;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('mouseenter', function () {
        setActive(this.dataset.megaTarget);
      });
      tab.addEventListener('focus', function () {
        setActive(this.dataset.megaTarget);
      });
      tab.addEventListener('click', function () {
        setActive(this.dataset.megaTarget);
      });
    });

    details.dataset.megaMenuReady = 'true';
    setActive(tabs[0].dataset.megaTarget);
  }

  function normalizeName(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function getDrawerItemName(item) {
    if (!item) return '';
    return normalizeName(item.dataset.name || item.textContent);
  }

  function showCustomPanel(drawer, nextPanel) {
    if (!drawer || !nextPanel) return;

    const currentPanel = drawer.querySelector('.customize_menu-drawer-right.show-customize_menu');
    if (currentPanel === nextPanel) {
      nextPanel.classList.add('is-visible');
      return;
    }

    if (currentPanel) {
      currentPanel.classList.remove('is-visible');
      window.setTimeout(function () {
        if (!currentPanel.classList.contains('is-visible')) {
          currentPanel.classList.remove('show-customize_menu');
        }
      }, CUSTOM_DRAWER_ANIMATION_MS);
    }

    nextPanel.classList.add('show-customize_menu');
    requestAnimationFrame(function () {
      nextPanel.classList.add('is-visible');
    });
  }

  function initCustomDrawer(drawer) {
    if (!drawer || drawer.dataset.customDrawerReady === 'true') return;

    const items = Array.from(drawer.querySelectorAll('.customize_menu-drawer-left li'));
    const panels = Array.from(drawer.querySelectorAll('.customize_menu-drawer-right[data-name]'));
    if (!items.length || !panels.length) return;

    function setActiveByName(name) {
      const nextName = normalizeName(name);
      const nextPanel = panels.find(function (panel) {
        return normalizeName(panel.dataset.name) === nextName;
      });

      if (!nextPanel) return;

      items.forEach(function (item) {
        const active = getDrawerItemName(item) === nextName;
        item.classList.toggle('active', active);
        if (item.hasAttribute('aria-selected')) {
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        }
      });

      showCustomPanel(drawer, nextPanel);
    }

    const leftList = drawer.querySelector('.customize_menu-drawer-left ul');
    if (leftList) {
      items.forEach(function (item) {
        item.addEventListener('mouseenter', function () {
          setActiveByName(getDrawerItemName(item));
        });
      });

      leftList.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;

        const item = event.target.closest('li');
        if (!item || !leftList.contains(item)) return;

        event.preventDefault();
        setActiveByName(getDrawerItemName(item));
      });
    }

    drawer.dataset.customDrawerReady = 'true';

    const defaultItem = items.find(function (item) {
      return item.classList.contains('active');
    }) || items[0];
    setActiveByName(getDrawerItemName(defaultItem));
  }

  function initAll() {
    updateHeaderBottomPosition();
    document.querySelectorAll('.mega-menu').forEach(initMegaMenu);
    document.querySelectorAll('.customize_menu-drawer').forEach(initCustomDrawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  window.addEventListener('resize', updateHeaderBottomPosition);
  window.addEventListener('scroll', updateHeaderBottomPosition, { passive: true });
})();
